export default __webpack_public_path__ + "static/media/profileCamera.1928377a.svg";